<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoDetalhar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoDetalhar">
			<form >
				<div class="formgroup">
					<div class="flex justify-content-center mt-3" *ngIf="loading">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="w-auto mb-5">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
					<div class="p-fluid p-formgrid grid pt-3 px-3 mb-5" *ngIf="operacao && !loading">
						<div class="col-12 card-simple">
							<div class="p-fluid p-formgrid grid">
								<div class="col-12 md:col-6 xl:col-3">
									<label class="label-superior">Descrição</label>
									<label class="label-inferior" id="descricao">{{ operacao.descricao }}</label>
								</div>
								<div class="col-12 md:col-6 xl:col-1">
									<label class="label-superior">Receita</label>
									<label class="label-inferior" id="receita">{{ operacao.receita ? 'SIM' : 'NÃO' }}</label>
								</div>
								
								<div class="col-12 md:col-6 xl:col-1">
									<label class="label-superior">Despesa</label>
									<label class="label-inferior" id="despesa">{{ operacao.despesa ? 'SIM' : 'NÃO' }}</label>
								</div>
								<div class="col-12 md:col-6 xl:col-1">
									<label class="label-superior">Interno</label>
									<label class="label-inferior" id="interno">{{ operacao.interno ? 'SIM' : 'NÃO' }}</label>
								</div>
		
								<div class="col-12 md:col-6 xl:col-1">
									<label class="label-superior">Status</label>
									<div class="label-inferior">
										<label class="product-badge status-instock" id="status" *ngIf="operacao.status">ATIVO</label>
										<label class="product-badge status-outofstock" id="status" *ngIf="!operacao.status">INATIVO</label>
									</div>
								</div>
		
								<div class="col-12 md:col-6 xl:col-2">
									<label class="label-superior">Conta</label>
									<label class="label-inferior" id="conta">{{ operacao.conta?.descricao }}</label>
								</div>
							</div>
						</div>

						

					</div>

					<div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loading">
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button"  pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/operacao-financeira"></button>
						</div>
					</div>

				</div>
			</form>
		</div>
	</div>
</div>